module.exports = __webpack_public_path__ + "static/media/img-attire-clothes.d9d9739a.svg";